import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import FormikTextField from '../../../FormikFields/FormikTextField';
import { getLocalizedDate, getLocalizedLabel } from '../../../../helpers/localize';
import genderItems from '../../../Patients/constants';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  section: {
    width: '100%',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4),
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2.5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
      borderRadius: 8,
    },
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.colors?.blue2 || '#122056',
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.colors?.lightBlue || '#5B65DC'}`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginBottom: theme.spacing(1),
    },
  },
  sectionContent: {
    marginTop: theme.spacing(2),
    maxWidth: 1000,
    width: '100%',
  },
  patientInfoGrid: {
    '& .MuiGrid-item': {
      paddingBottom: '0 !important',
    },
  },
}));

const PatientInfoSection = ({ patientInfo }) => {
  const classes = useStyles();
  const { en: { forms } } = useSelector((state) => state.i18n);

  return (
    <div className={classes.section}>
      <Typography className={classes.sectionTitle}>
        {forms.patientInformation || 'Patient Information'}
      </Typography>
      <div className={classes.sectionContent}>
        <Grid container spacing={3} className={classes.patientInfoGrid}>
          <Grid item xs={12} md={6}>
            <FormikTextField
              type='text'
              name='patient'
              label={forms.patient}
              value={patientInfo.name}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormikTextField
              type='text'
              name='gender'
              label={forms.gender}
              value={getLocalizedLabel(genderItems, patientInfo.gender)}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormikTextField
              type='text'
              name='dateOfBirth'
              label={forms.dateOfBirth}
              value={getLocalizedDate(patientInfo.dateOfBirth, 'UTC')}
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              type='text'
              name='dob'
              label={forms.allergies}
              value={patientInfo.drugAllergies || forms.noDrugAllergies}
              multiline
              rows='5'
              disabled
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

PatientInfoSection.propTypes = {
  patientInfo: PropTypes.shape({
    name: PropTypes.string,
    gender: PropTypes.string,
    dateOfBirth: PropTypes.string,
    drugAllergies: PropTypes.string,
  }).isRequired,
};

export default PatientInfoSection;
